"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdBusinessRegion = void 0;
const Region_1 = require("./Region");
class BusinessRegion {
    constructor({ key, idBusinessRegion, timeZone, }) {
        this.toJSON = () => ({
            key: this.key,
            idBusinessRegion: this.idBusinessRegion,
            timeZone: this.timeZone,
        });
        this.key = key;
        this.idBusinessRegion = idBusinessRegion;
        this.timeZone = timeZone;
    }
}
BusinessRegion.fromJSON = (json) => {
    const { key, idBusinessRegion, timeZone } = Object.assign({}, json);
    if (key !== undefined && Object.keys(Region_1.Region).indexOf(key) === -1)
        throw new Error('.key must be any one of Region');
    if (idBusinessRegion !== undefined && Object.keys(exports.IdBusinessRegion).indexOf(idBusinessRegion) === -1)
        throw new Error('.idBusinessRegion must be any one of IdBusinessRegion');
    if (timeZone !== undefined && typeof timeZone !== 'string')
        throw new Error('.timeZone must be a string');
    return new BusinessRegion({ key, idBusinessRegion, timeZone });
};
exports.IdBusinessRegion = {
    japan: 'japan',
    united_states: 'united_states',
    global: 'global',
};
exports.default = BusinessRegion;
